// 9fbef606107a605d69c0edbcd8029e5d

const COUPON_SELF_HELP_CONSTANT = {
  INACTIVE_ERR_CODE: `ERR_PROMOTION_CODE_VALUE_DUPLICATE`,
  USED_ERR_CODE: `USED`,
  EXPIRED_ERR_CODE: `EXPIRED`,
};

export default COUPON_SELF_HELP_CONSTANT;
